import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CountdownStrip from './components/CountdownStrip';
import FeatureCards from './components/FeatureCards';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="min-h-screen w-full" style={{ background: '#0A0A0A' }}>
      <Navbar />
      <Hero />

      {/* Thin separator */}
      <div className="w-full" style={{ borderTop: '1px solid rgba(201,168,76,0.1)' }} />

      {/* Quote strip */}
      <section
        className="w-full py-16 px-6 md:px-12 flex flex-col items-center text-center"
        style={{ background: '#0D0D0D' }}
      >
        <i
          className="ri-double-quotes-l text-4xl mb-6"
          style={{ color: 'rgba(201,168,76,0.3)' }}
        />
        <blockquote
          className="max-w-3xl text-xl md:text-2xl font-light leading-relaxed italic mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif", color: 'rgba(245,240,232,0.75)' }}
        >
          The man dies in all who keep silent in the face of tyranny.
        </blockquote>
        <cite
          className="text-xs tracking-widest uppercase"
          style={{ fontFamily: "'Inter', sans-serif", color: '#C9A84C', fontStyle: 'normal' }}
        >
          — Wole Soyinka
        </cite>
      </section>

      {/* Countdown */}
      <section
        className="w-full py-4"
        style={{
          background: '#0A0A0A',
          borderTop: '1px solid rgba(201,168,76,0.08)',
          borderBottom: '1px solid rgba(201,168,76,0.08)',
        }}
      >
        <CountdownStrip />
      </section>

      {/* Feature Cards */}
      <section className="w-full py-6" style={{ background: '#0A0A0A' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-12 mb-8 text-center">
          <span
            className="text-[10px] tracking-[0.3em] uppercase"
            style={{ fontFamily: "'Inter', sans-serif", color: '#9A9A8A' }}
          >
            What awaits you
          </span>
          <h2
            className="text-3xl md:text-4xl font-light mt-3"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: '#F5F0E8' }}
          >
            Inside the Sanctuary
          </h2>
        </div>
        <FeatureCards />
      </section>

      {/* Second quote / pull quote */}
      <section
        className="w-full py-20 px-6 md:px-12 relative overflow-hidden"
        style={{ background: '#0D0D0D' }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.04) 0%, transparent 70%)',
          }}
        />
        <div className="relative max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12">
          <div
            className="w-48 h-56 md:w-64 md:h-80 rounded-2xl overflow-hidden flex-shrink-0"
            style={{ border: '1px solid rgba(201,168,76,0.2)' }}
          >
            <img
              src="https://www.theaccessbankukltd.co.uk/wp-content/uploads/2022/01/An-Evening-with-Professor-Wole-Soyinka-1.jpg"
              alt="Professor Wole Soyinka"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="flex flex-col gap-6 text-left">
            <div
              className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full self-start"
              style={{ border: '1px solid rgba(139,58,42,0.4)', background: 'rgba(139,58,42,0.08)' }}
            >
              <span
                className="text-[10px] tracking-widest uppercase"
                style={{ fontFamily: "'Inter', sans-serif", color: '#8B3A2A' }}
              >
                Nobel Prize · Literature · 1986
              </span>
            </div>
            <p
              className="text-lg md:text-xl font-light leading-relaxed"
              style={{ fontFamily: "'Cormorant Garamond', serif", color: 'rgba(245,240,232,0.7)' }}
            >
              Akinwande Oluwole Babatunde Soyinka, born 13 July 1934 in Abeokuta, Nigeria, transformed African theatre and literature, becoming in 1986 the first sub-Saharan African writer to be awarded the Nobel Prize in Literature.
            </p>
            <p
              className="text-sm font-light leading-relaxed"
              style={{ fontFamily: "'Inter', sans-serif", color: '#6B6B60' }}
            >
              His works weave Yoruba mythology, sharp political critique, and universal humanity into an oeuvre that continues to resonate across continents and generations.
            </p>
            <div className="flex flex-wrap gap-3 mt-2">
              {['Playwright', 'Poet', 'Novelist', 'Political Activist', 'Nobel Laureate'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 rounded-full text-[10px] tracking-widest uppercase"
                  style={{
                    border: '1px solid rgba(245,240,232,0.12)',
                    color: 'rgba(245,240,232,0.4)',
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </main>
  );
}
